// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gZ","advertCardHeader__actions":"c-a_ha","advertCardHeader__bottomLabel":"c-a_hb"};